import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debug } from 'console';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { abridgedclass, modulemedia } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import * as hdate from 'human-date';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-module-media-library',
  templateUrl: './media-library.component.html',
  styleUrls: ['./media-library.component.css']
})
export class ModuleMediaLibraryComponent implements OnInit, OnDestroy {
  @Input() moduleid: number = 0;
  @Input() classid: number = 0;
  moduleInfo: any = {};
  currentUserIsAdmin: boolean = false;
  adminActions: AdminAction[];
  breadcrumbs: BreadCrumb[];
  medialist: modulemedia[] = [];
  @Input() enableselect: boolean = false;
  modulemedialibraryurlsegment: any;
  schoolallocatedmediastorage:any;
  schoolfreemediastorage:any;
  schoolusedmediastorage:any;
  @Output() mediaSelected: EventEmitter<modulemedia> = new EventEmitter<modulemedia>();
  //refreshinterval;
  //schoolName: string;
  //schoolID: number;

  constructor(private activatedroute: ActivatedRoute, private modulemanager: ModulemanagementService, private classmanager: ClassmanagementService, private headerinfo: ComponentheaderService, private toastr: ToastrService, private util: UtilService) { 
    this.modulemedialibraryurlsegment = this.activatedroute.snapshot.url.find((segment) => { 
      //debugger;
      return segment.path == 'modulemedialibrary' 
    });
    if(this.modulemedialibraryurlsegment){
      this.headerinfo.setHeaderDisplay('Loading...', [], []);
    }
  }
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    //debugger;
    //console.log(`enableselect = ${this.enableselect}`);
    if(!this.moduleid){
      this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid ?? "0");
    }
    if(!this.classid){
      this.classid = parseInt(this.activatedroute.snapshot.queryParams.classid ?? "0");
    }

    //debugger;
    // this.util
    //   .getSchoolAccountDashboardInfo()
    //   .toPromise()
    //   .then((response: any) => {
    //    // debugger;
    //     this.schoolallocatedmediastorage = this.humanFileSize(
    //       response.storage.accountStorageBytes,true
    //     ); 
    //     this.schoolfreemediastorage = this.humanFileSize(
    //       response.storage.freeStorageBytes,true
    //     );
    //     this.schoolusedmediastorage = this.humanFileSize(
    //       response.storage.usedStorageBytes,true
    //     );

       
     
    //   });

    let classdetailsabridged: abridgedclass;
    if(this.classid && !this.moduleid){
      classdetailsabridged = await this.classmanager.getClassDetailsAbridged(this.classid).toPromise();
      this.moduleid = classdetailsabridged.moduleid;
    }
    this.enableselect = this.enableselect || this.activatedroute.snapshot.queryParams.enableselect == "1";
    const data: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
    this.moduleInfo = data.moduleinfo;
    this.currentUserIsAdmin = data.isViewerAdmin;
    const schoolName: string = data.schoolName;
    const schoolid: number = data.schoolID;
    let moduleDisplayName = this.moduleInfo.name;

    if(this.moduleInfo.courseCode){
      moduleDisplayName += ` (${this.moduleInfo.courseCode})`;
    }
    if(this.currentUserIsAdmin){
      this.adminActions = [{displaytext: 'Upload Audio/Video', route: '/user/uploadmedia', params: {moduleid: this.moduleid}, classes: ['fas', 'fa-cloud-upload-alt']}, 
                            {displaytext: 'Upload Vcirle Recording', route: '/user/uploadvcirclemedia', params: {moduleid: this.moduleid}, classes: ['fas', 'fa-cloud-upload-alt']}, 
                           //{ displaytext: 'Record Video', route: '/recordvideo', params: { moduleid: this.moduleid }, classes: ['fas', 'fa-video'] },
                          //  {displaytext: 'Add from Youtube', route: '/user/addyoutubemedia', params: {moduleid: this.moduleid}}
                           /*{displaytext: 'Record Video', route: '/user/recordvideo', params: {moduleid: this.moduleid}}, */
                          ];
    }
    else{
      this.adminActions = [];
    }

    this.breadcrumbs = [
      
      {displaytext: "School", route: `/user/schoolhome` }
    ];

    this.breadcrumbs.push({displaytext: "Course", route: `/user/moduledetails`, params: {moduleID: this.moduleid}});

    if(this.classid){
      if(!classdetailsabridged){
        classdetailsabridged = await this.classmanager.getClassDetailsAbridged(this.classid).toPromise();
      }
      this.breadcrumbs.push({displaytext: classdetailsabridged.title, route: `/user/lesson`, params: {classid: this.classid}});
    }

    this.breadcrumbs.push({displaytext: 'Module Media Library', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams});

    if(this.modulemedialibraryurlsegment){
      this.headerinfo.setHeaderDisplay(
        'Media Library', 
        this.breadcrumbs,
        this.adminActions);
    }
    this.medialist = await this.modulemanager.getMedia(this.moduleid).toPromise();

    // const mythis = this;
    // setInterval(async function () {
    //   mythis.medialist = await mythis.modulemanager.getMedia(mythis.moduleid).toPromise<modulemedia[]>();
    // }, 1000);

    this.headerinfo.pageLoadingDone(this);
    // for(let i = 0; i < this.medialist.length; i++){
    //   this.medialist[i] = <modulemedia>this.medialist[i];
    // }
    // debugger;
  }

  async deleteConfirmed(media: modulemedia){
    await this.modulemanager.deleteMedia(media.moduleid, media.uploadid).toPromise();
    //debugger;
    for(let i = 0; i < this.medialist.length; i++){
      if(media.id == this.medialist[i].id){
        //debugger;
        this.medialist.splice(i, 1);
        break;
      }
    }

    this.toastr.warning('Media Deleted');
  }

  totalMediaSizeFormatted(){
    let total: number = 0;
    for(let i = 0; i < this.medialist.length; i++){
      total += this.medialist[i].size;
    }
    return this.humanFileSize(total, true);
  }

  humanFileSize(bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }

  mediaSelectedHandler(media: modulemedia){
    this.mediaSelected.emit(media);
  }

  selectVideoFromYoutube(){
  }
}
